import { search, scrollToProducts } from "algolia-instant-search";

const { connectToggleRefinement } = instantsearch.connectors;

if (!customElements.get("algolia-toggle-filter")) {
  class AlgoliaToggleFilter extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector("template#filter-group");
      this.content = this.querySelector("#content");
      this.attribute = this.dataset.attribute;
      this.heading = this.dataset.heading;
      this.onValue = this.dataset.onValue;

      const toggleFilter = connectToggleRefinement(
        this.renderToggleFilter.bind(this),
      );

      search.addWidgets([
        toggleFilter({
          attribute: this.attribute,
          on: this.onValue,
        }),
      ]);
    }

    renderToggleFilter(renderOptions, isFirstRender) {
      const { value, refine } = renderOptions;

      if (isFirstRender) {
        this.content.appendChild(this.template.content.cloneNode(true));
        this.input = this.content.querySelector("input");
        this.clearButton = this.content.querySelector(".jsFilterGroupClear");

        this.input.addEventListener("change", (event) => {
          refine({ isRefined: !event.target.checked });
          scrollToProducts();
        });

        this.clearButton.addEventListener("click", (event) => {
          event.preventDefault();
          if (this.input.checked) {
            refine({ isRefined: true });
            scrollToProducts();
          }
        });
      }

      this.input.checked = value.isRefined;
      this.clearButton.classList.toggle("none", !value.isRefined);
    }
  }

  customElements.define("algolia-toggle-filter", AlgoliaToggleFilter);
}
